export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13805.246c1ca3.jpg";